export function isStartpage(page: ImmutableMap): boolean {
  return page.get('href') === '/'
}
